import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LogoutComponent } from './logout.component';
import { UnauthorizedComponent } from './unauthorized.component';

const routes: Routes = [
  {
    path: 'auth/logout',
    data: { 'hideNavOptions': true },
    component: LogoutComponent
  },
  {
    path: 'auth/unauthorized',
    component: UnauthorizedComponent,
    data: { 'hideNavOptions': true }
  }
]

//export const AuthRoutingModule: ModuleWithProviders = RouterModule.forChild(routes);
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
